import { Box } from '@chakra-ui/react';
import * as _ from 'lodash';
import React, { useState, useEffect, useMemo } from 'react';

import { SearchBarInput } from 'packages/common-frontend/components/SearchAndCopyComponents';

export const AliasMatchingFilters = ({
  setSearchQuery,
}: {
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [query, setQuery] = useState('');

  const setAliasMappingSearchQuery = useMemo(
    () =>
      _.debounce((q: string) => {
        setSearchQuery(q);
      }, 400),
    [setSearchQuery],
  );

  useEffect(() => {
    setAliasMappingSearchQuery(query);
  }, [query, setAliasMappingSearchQuery]);

  return (
    <Box mt="2.5rem">
      <SearchBarInput
        query={query}
        onChangeQuery={setQuery}
        placeholder="Search by LP alias or name"
      />
    </Box>
  );
};
